import { useFormContext, 
// eslint-disable-next-line no-restricted-imports
useController as useRhfController, } from 'react-hook-form';
export const useController = (props) => {
    const context = useFormContext();
    if (!context) {
        console.dev.warn(`The \`useController\` hook should be used inside the \`FormProvider\` to prevent incorrect behavior of memoized fields. Please wrap the form in the \`FormProvider\` component.\nRelated issue: https://gitlab.audienzz.ch/audienzz/audienzz/-/issues/17559`);
    }
    return useRhfController(props);
};
